<template>
  <ModalCard>
    <template #custom>
      <div class="py-5 iframe-container">
        <FeeScheduleIFrame :is-clear-vault="isClearVault" height="100%" />
      </div>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import FeeScheduleIFrame from '@/modules/billing/components/checkout/FeeScheduleIFrame.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FeeScheduleModal',
  components: { FeeScheduleIFrame, ModalCard },
  props: {
    isClearVault: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 60px);
}
</style>
